import { render, staticRenderFns } from "./OptimisationDelivery.vue?vue&type=template&id=1156eac1&scoped=true&"
import script from "./OptimisationDelivery.vue?vue&type=script&lang=js&"
export * from "./OptimisationDelivery.vue?vue&type=script&lang=js&"
import style0 from "./OptimisationDelivery.vue?vue&type=style&index=0&id=1156eac1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156eac1",
  null
  
)

export default component.exports